import {
  Modal,
  Form,
  Button,
  InputGroup,
  Table,
  Dropdown,
} from "react-bootstrap";
import "./../../assets/scss/new-entity-modal.scss";
import Select from "react-select";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import { DeleteIcon, EditIcon, NoSelectedItemIcon } from "./../Icons";
import NumberCustomInput from "../utils/NumberCustomInput";
import DateTime from "react-datetime";
import { useAuth } from "../../hooks/useAuth";
import { useMutation } from "react-query";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import currency from "currency.js";
import moment from "moment";
import { toast } from "react-toastify";
import CachedIcon from "mdi-react/CachedIcon";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Popover } from "react-tiny-popover";
import {
  qtyFormat,
  qtyFormatToString,
  scrollToElement,
  styleHelper,
  tonsToPcs,
} from "./../../utils/helpers";
import { isEmpty } from "lodash";
import { useStoreState } from "easy-peasy";
import { useRef } from "react";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ModalLoader from "../utils/ModalLoader";
import ProcessPlantSelector from "./ProcessPlantSelector";
import ConfirmDialog from "../ConfirmDialogue";

const pointsOfDamages = [
  {
    label: "Company store",
    value: "Company store",
  },
  {
    label: "Transit",
    value: "Transit",
  },
  {
    label: "Customer Possession",
    value: "Customer Possession",
  },
  {
    label: "Manufacturer",
    value: "Manufacturer",
  },
  {
    label: "Point of sales",
    value: "Point of sales",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export default function DamageItemModal({
  showDamageItemModal,
  setShowDamageItemModal,
  refetch,
  isMulti = true,
}) {
  const barcodeInputRef = useRef();
  const itemMeasurements = useStoreState((state) => state.itemMeasurements);
  const { backendUrl, token } = useAuth();

  const [showPurchaseHistoryPopover, setShowPurchaseHistoryPopover] = useState(
    false
  );
  const [tableData, setTableData] = useState([]);

  const plantLocal = JSON.parse(window.localStorage.getItem("plantDetails"));

  const formik = useFormik({
    initialValues: {
      FaultID: `FLT${Date.now()}`,
      Barcode: "",
      Item_Name: "",
      Quantity: "",
      Vendor: "",
      PointOfDamage: "Company store",
      Faults: "",
      CompanySentTo: "",
      DamageStatus: "Active",
      CompanyAddress: "",
      EntryDate: moment(),
      DateResolved: moment(),
      Usage: "Sales",
      Product_Model: "",

      UnitCost: "",
      amount: "",

      Product_Name: "",
      Cat_Name: "",
      Branch: "HQ",
      quantityInStock: "",
      Item_Desc: "",
    },
    validationSchema: yup.object().shape({
      Barcode: yup.string().required("Item Code is required"),
      Item_Name: yup.string().required("Item Name is required"),
      Quantity: yup.string().required(),
      FaultID: yup.string().required("FaultId is required"),
    }),
    onSubmit: async (values) => {
      if (isMulti) {
        // Check if we have enough
        const realQuantity =
          values.Unit === "Tons"
            ? tonsToPcs(values.Quantity, values?.Item_Desc, itemMeasurements)
            : values.Quantity;

        console.log(realQuantity, values.quantityInStock);
        if (Number(realQuantity) > Number(values?.quantityInStock)) {
          return formik.setFieldError(
            "Quantity",
            `Not enough Ouantity in stock`
          );
        }
        const foundIndex = tableData.findIndex(
          (el) => el.FaultID === values.FaultID
        );

        if (foundIndex !== -1) {
          tableData[foundIndex] = values;
          setTableData([...tableData]);
        } else {
          setTableData([...tableData, values]);
        }

        formik.resetForm();
        formik.setFieldValue("FaultID", `FLT${Date.now()}`);
        barcodeInputRef.current.focus();
        return;
      }
    },
    onReset: () => {
      // handleSelectedItem(null);
    },
  });

  const recordDamage = async (payload) => {
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    let response = await fetch(`${backendUrl}/api/production/record-damage`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        /*  Accept: "Application/json",
        "Content-Type": "Application/json", */
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const recordDamageMutation = useMutation((payload) => recordDamage(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
      formik.resetForm();
      if (refetch) refetch();
      setShowDamageItemModal(false);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const handleSelectedItem = (item) => {
    formik.resetForm();
    formik.setValues({
      ...formik.values,
      Item_Type: item.Item_Type,
      Barcode: item.Bar_Code,
      Item_Name: item.Item_Name,
      Product_Model: item.Product_Model,
      Quantity: "",
      Date_Log: moment(new Date(item.Date_Log)),
      Product_Name: item.Product_Name,
      Cat_Name: item.Cat_Name,
      plant: plantLocal.PLID,

      // ----------
      quantityInStock: item.Quantity,
      Item_Desc: item.Item_Desc,

      // -----------
      UnitCost: item.UnitCost,
      Vendor: item.RequestID,
      CompanySentTo: item?.RequestID,
      CompanyAddress: item?.RequestID,
    });
    scrollToElement('input[name="Quantity"]', { scroll: false });
  };

  const handleSelectedItemToEdit = (item) => {
    formik.resetForm();
    formik.setValues({
      ...formik.values,
      ...item,
    });
    scrollToElement('input[name="Quantity"]', { scroll: false });
  };

  const handleRemoveItem = (index) => {
    setTableData([...tableData.filter((el, i) => i !== index)]);
  };

  const saveMulti = async () => {
    if (
      await ConfirmDialog({
        title: "Send Damage(s)",
        description: "Are you sure you want to send this Damage(s)",
      })
    ) {
      console.log(tableData);
      recordDamageMutation.mutate({
        isMulti: true,
        stockItems: tableData,
      });
    }
  };

  const calculateAmount = (Quantity, UnitCost) => {
    formik.setFieldValue(
      "amount",
      currency(Quantity, {
        symbol: "",
        separator: "",
      })
        .multiply(UnitCost)
        .format()
    );
  };

  const handleSelectedPurchaseHistory = (purchase) => {
    // console.log(purchase);
    setShowPurchaseHistoryPopover(false);
    handleSelectedItem(purchase);
  };

  return (
    <Modal
      show={showDamageItemModal}
      onHide={() => setShowDamageItemModal(false)}
      dialogClassName={`new-entity-modal ${isMulti ? "multi-update" : ""}`}
      backdropClassName={`global-backdrop`}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
      fullscreen={styleHelper.isMobile}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1>
            Enter Damage Item Information{" "}
            <CachedIcon
              onClick={() => formik.resetForm()}
              className="text-primary"
            />{" "}
          </h1>
          <p>Add new item by filling in the following forms.</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`px-0 ${isMulti ? "d-md-flex pb-1" : ""}`}>
        <Form
          noValidate
          onSubmit={formik.handleSubmit}
          className={`row new-item-form w-100 m-0 ${
            isMulti ? "flex-column border rounded mx-4" : ""
          } `}
          autoComplete="off"
        >
          <div className={`${isMulti ? "w-auto pt-4" : "col-md-6 px-4"}`}>
            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Bar Code</Form.Label>
              <InputGroup>
                <Form.Control
                  className=""
                  type="text"
                  name="Barcode"
                  value={formik.values.Barcode}
                  onChange={formik.handleChange}
                  isInvalid={formik.touched.Barcode && !!formik.errors.Barcode}
                  ref={barcodeInputRef}
                  readOnly
                />

                <Popover
                  isOpen={showPurchaseHistoryPopover}
                  onClickOutside={() => setShowPurchaseHistoryPopover(false)}
                  content={() => (
                    <ProcessPlantSelector
                      handleSelectedPurchaseHistory={
                        handleSelectedPurchaseHistory
                      }
                      plantLocal={plantLocal}
                    />
                  )}
                  position="bottom"
                >
                  <InputGroup.Text
                    onClick={() =>
                      setShowPurchaseHistoryPopover(!showPurchaseHistoryPopover)
                    }
                  >
                    <MagnifyIcon />
                  </InputGroup.Text>
                </Popover>
              </InputGroup>
              <Form.Control.Feedback type="invalid">
                {formik.errors.Barcode}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Item Name</Form.Label>
              <Form.Control
                className=""
                type="text"
                placeholder="Enter Item Name"
                name="Item_Name"
                value={formik.values.Item_Name}
                onChange={formik.handleChange}
                isInvalid={
                  formik.touched.Item_Name && !!formik.errors.Item_Name
                }
                readOnly
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.Item_Name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Fault ID</Form.Label>
              <Form.Control
                className=""
                type="text"
                placeholder="Enter FaultID"
                name="FaultID"
                value={formik.values.FaultID}
                onChange={formik.handleChange}
                isInvalid={formik.touched.FaultID && !!formik.errors.FaultID}
                readOnly
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.FaultID}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 pb-2">
              <Form.Label>Quantity</Form.Label>
              <NumberCustomInput
                placeholder="0"
                name="Quantity"
                value={formik.values.Quantity}
                onValueChange={(value, name) => {
                  formik.setFieldValue(name, value);
                  calculateAmount(value, formik.values.UnitCost);
                }}
                isInvalid={formik.touched.Quantity && !!formik.errors.Quantity}
                onBlur={() => formik.setFieldTouched("Quantity", true)}
              />
              {formik.touched.Quantity && !!formik.errors.Quantity ? (
                <span className="custom-invalid-feedback">
                  {formik.errors.Quantity}
                </span>
              ) : null}
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Quantity In Stock</Form.Label>
              <Form.Control
                placeholder="Quantity In Stock"
                value={
                  formik.values?.quantityInStock
                    ? qtyFormatToString(
                        qtyFormat(
                          formik.values?.quantityInStock,
                          formik.values?.Item_Desc,
                          itemMeasurements
                        )
                      )
                    : "..."
                }
                readOnly
              />
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1"> Cost Price</Form.Label>
              <CurrencyCustomInput
                name="UnitCost"
                placeholder="0.00"
                value={formik.values.UnitCost}
                onValueChange={(value, name) => {
                  formik.setFieldValue(name, value);
                  calculateAmount(value, formik.values.Quantity);
                }}
                isInvalid={formik.touched.UnitCost && !!formik.errors.UnitCost}
                onBlur={() => formik.setFieldTouched("UnitCost", true)}
              />
              {formik.touched.UnitCost && !!formik.errors.UnitCost ? (
                <span className="custom-invalid-feedback">
                  {formik.errors.UnitCost}
                </span>
              ) : null}
              <Form.Control.Feedback type="invalid" />
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Point of Damage</Form.Label>
              <Select
                classNamePrefix={"form-select"}
                options={pointsOfDamages}
                value={pointsOfDamages?.find(
                  (el) => el.value === formik.values.PointOfDamage
                )}
                onChange={({ value }) =>
                  formik.setFieldValue("PointOfDamage", value)
                }
                isSearchable={false}
              />
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Fault</Form.Label>
              <Form.Control
                as="textarea"
                name="Faults"
                placeholder="Enter Faults"
                value={formik.values.Faults}
                onChange={formik.handleChange}
              />
            </Form.Group>

            <hr />

            <Form.Group className="mb-3 pb-2">
              <Form.Label className="mb-1">Tran Date</Form.Label>
              <DateTime
                timeFormat={false}
                closeOnSelect={true}
                closeOnClickOutside={true}
                dateFormat="MMM DD, YYYY"
                inputProps={{
                  className: `date-input form-control`,
                  placeholder: "Select date",
                  readOnly: true,
                }}
                value={formik.values.EntryDate}
                onChange={(date) => {
                  formik.setFieldValue("EntryDate", date, true);
                }}
              />
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1"> Amount</Form.Label>
              <CurrencyCustomInput
                name="amount"
                placeholder="0.00"
                value={formik.values.amount}
                onValueChange={(value, name) => {
                  formik.setFieldValue(name, value);
                }}
                isInvalid={formik.touched.amount && !!formik.errors.amount}
                onBlur={() => formik.setFieldTouched("amount", true)}
                disabled={true}
              />
              {formik.touched.amount && !!formik.errors.amount ? (
                <span className="custom-invalid-feedback">
                  {formik.errors.amount}
                </span>
              ) : null}
              <Form.Control.Feedback type="invalid" />
            </Form.Group>
          </div>

          {isMulti && (
            <div className="d-flex justify-content-end py-3 add-to-cart-holder">
              <Button
                variant="outline-primary"
                type="submit"
                className="action-btn"
              >
                Add To Cart
              </Button>
            </div>
          )}
        </Form>

        {isMulti && (
          <div className="item-cart-area px-4">
            {!isEmpty(tableData) ? (
              <>
                {" "}
                <h2 className="mb-4">Item Cart</h2>
                <Table
                  responsive
                  borderless
                  striped
                  className="product-table text-nowrap"
                >
                  <thead>
                    <tr>
                      <th />
                      <th>Fault ID</th>
                      <th>Barcode</th>
                      <th>Item Name</th>
                      <th>Quantity</th>
                      <th>Vendor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((el, index) => (
                      <tr key={index} className="p-cursor">
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant=""
                              className="bg-white border-0"
                              bsPrefix="print more"
                            >
                              <DotsVerticalIcon />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              popperConfig={{
                                strategy: "fixed",
                              }}
                              renderOnMount
                              className="dropdown-with-icons"
                            >
                              <Dropdown.Item
                                as="button"
                                onClick={() => handleSelectedItemToEdit(el)}
                              >
                                <EditIcon />
                                Edit Item
                              </Dropdown.Item>
                              <Dropdown.Item
                                as="button"
                                onClick={() => handleRemoveItem(index)}
                              >
                                <DeleteIcon />
                                Remove Item
                              </Dropdown.Item>
                            </Dropdown.Menu>{" "}
                          </Dropdown>
                        </td>
                        <td>{el.FaultID}</td>
                        <td>{el.Barcode}</td>
                        <td>{el.Item_Name}</td>
                        <td>
                          {currency(el.Quantity, { symbol: "" }).format()}{" "}
                          {["Tons", "Pieces"].includes(el.Unit) ? el.Unit : ""}
                        </td>
                        <td>{el.CompanySentTo}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-between save-btn-holder mt-4">
                  <div className="gridChild gridChildBorderLeftBlue">
                    <div className="gridChildLeft">
                      <p className="gridChld1">
                        {currency(
                          tableData
                            .map((el) => el.amount)
                            .reduce(
                              (a, b) =>
                                currency(a, {
                                  precision: 2,
                                }).add(b),
                              0
                            ),
                          {
                            symbol: "₦",
                          }
                        ).format()}
                      </p>
                      <p className="gridChld2">Total</p>
                    </div>
                  </div>
                  <Button
                    disabled={recordDamageMutation.isLoading}
                    className="action-btn save-btn"
                    onClick={() => saveMulti()}
                  >
                    Post
                  </Button>
                </div>
              </>
            ) : (
              <div className="no-item my-5 py-4">
                <div className="info">
                  <NoSelectedItemIcon />
                  <h2 className="mb-1">No Item Selected</h2>
                  <p>
                    Please select an item and fill in the <br />
                    pricing details.
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>

      <ModalLoader show={recordDamageMutation.isLoading} />
    </Modal>
  );
}
